import { render, staticRenderFns } from "./ConvertStu.vue?vue&type=template&id=32fa192a&scoped=true"
import script from "./ConvertStu.vue?vue&type=script&lang=js"
export * from "./ConvertStu.vue?vue&type=script&lang=js"
import style0 from "./ConvertStu.vue?vue&type=style&index=0&id=32fa192a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fa192a",
  null
  
)

export default component.exports